'use strict'

require('./helpers/breakpoints')
require('./helpers/lottie')
require('./helpers/lazy-load')
require('./helpers/popups')
require('./helpers/cookies')
require('./helpers/header')
require('./helpers/navigation')
require('./helpers/custom-select')
require('./helpers/cursor')
require('./helpers/form-validation')
require('./helpers/single-faq')

require('./setup')
require('./scroll-smoother')
require('./helpers/preloader')

require('./global_events')
require('./all-posts')

require('./sections/hero')
require('./sections/media-and-content')
require('./sections/featured-service')
require('./sections/vacancies-and-news')
require('./sections/map-markets-sectors')
require('./sections/map-locations')
require('./sections/members')
require('./sections/footer')
require('./sections/anchor-links-header')
require('./sections/slider-media-content')
require('./sections/participations')
require('./sections/timeline')
require('./sections/timeline-slider')
require('./sections/gallery')
require('./sections/finance-documents')
require('./sections/financial-news-block')
require('./sections/graphs-block')
require('./sections/accordion')
require('./form')






